import React from "react";
import { motion } from "framer-motion";
import { Award, Factory, Handshake, Package } from "lucide-react";

const stats = [
  { icon: Package, label: "Başlıca Ürün", value: "HALI HURCU" },
  { icon: Factory, label: "Yerli Üretim", value: "100%" },
  { icon: Award, label: "Profesyonel Kalite", value: "Uzman" },
  { icon: Handshake, label: "Müşteri Memnuniyeti", value: "Öncelik" },
];

const About = () => {
  return (
    <section
      id="hakkimizda"
      data-testid="about-section"
      className="py-20 lg:py-28 bg-white border-y border-slate-100"
    >
      <div className="container mx-auto px-6 lg:px-8 max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5"
          >
            <div className="text-xs font-bold tracking-[0.28em] uppercase text-[#2563EB]">
              Hakkımızda
            </div>
            <h2 className="mt-4 font-heading font-bold text-4xl sm:text-5xl text-[#0A192F] leading-[1.05] tracking-tight">
              Halı yıkamacılar için
              <br />
              <span className="text-[#2563EB]">tek noktadan çözüm.</span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <p className="text-lg text-slate-700 leading-relaxed">
              <span className="font-semibold text-[#0A192F]">HALIPAK</span>, halı yıkama
              sektörünün ihtiyaç duyduğu iki kritik ürünü tek çatı altında üreten bir
              kuruluştur. Başlıca ürünümüz <strong>HALIPAK Halı Hurcu</strong>{" "}
              ambalajımız ile temizlenmiş halıları koku, nem ve darbelere karşı korurken;
              profesyonel kimyasal formülasyonumuz <strong>PROCLEAN Halı Leke
              Çıkarıcı</strong> ile zorlu lekeleri söküyoruz.
            </p>
            <p className="mt-5 text-base text-slate-600 leading-relaxed">
              Yerli üretim, B2B odaklı fiyatlandırma ve Türkiye geneli hızlı gönderim
              ile halı yıkama firmalarının iş akışını hızlandırıyoruz. Kaliteden ödün
              vermeden, profesyonel sonuca giden en kısa yolu sunuyoruz.
            </p>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((s) => {
                const Icon = s.icon;
                return (
                  <div
                    key={s.label}
                    data-testid={`about-stat-${s.label}`}
                    className="rounded-2xl border border-slate-200 p-4 bg-[#F8FAFC] hover:bg-white hover:border-[#2563EB]/30 hover:-translate-y-0.5 transition-all duration-300"
                  >
                    <Icon className="w-5 h-5 text-[#2563EB]" />
                    <div className="mt-3 font-heading font-bold text-[#0A192F] text-base">
                      {s.value}
                    </div>
                    <div className="text-xs text-slate-500 mt-0.5">{s.label}</div>
                  </div>
                );
              })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
